import {
  type HttpEvent,
  type HttpHandlerFn,
  type HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { type Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { TenantService } from '../services/tenant/tenant.service';

/**
 * Interceptor to add tenant-identifying headers to all API requests.
 * This is crucial for SSR, as the original browser Host/Origin is lost
 * when the SSR server makes requests to the API.
 */
export function tenantInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const tenantService = inject(TenantService);

  // Only add headers if the request is going to our API
  if (req.url.startsWith(environment.apiUrl)) {
    const tenantHost = tenantService.getHostname();

    if (tenantHost) {
      const tenantReq = req.clone({
        setHeaders: {
          'x-tenant-host': tenantHost,
        },
      });
      return next(tenantReq);
    }
  }

  return next(req);
}
